import useUpdateDropTaskSubmissions from '../../../../hooks/useUpdateDropTaskSubmissions'
import SharedManualAPIRewardTask, {
  Props,
} from '../../../../shared_components/Missions/Types/ManualApiRewardWithLink'

export default function ManualAPIRewardTask(
  props: Omit<Props, 'updateTaskSubmissions' | 'taskAmount' | 'rewardDisplay'>,
) {
  const updateTaskSubmissions = useUpdateDropTaskSubmissions()
  return (
    <SharedManualAPIRewardTask
      {...props}
      updateTaskSubmissions={updateTaskSubmissions}
      rewardDisplay='XP'
    />
  )
}
